module.exports = __webpack_public_path__ + "media/images/lp/industries/solution-04-34377980ff85ba7bc703d5dc84946248.png";